import * as yup from 'yup';
import { z } from 'zod';

import { PHONE_NUMBER_REGEX } from '@clearverify/constants';

export const INVALID_PHONE_NUMBER_MESSAGE = 'Must be a valid phone number';

export const phoneNumberValidationSchema = yup
  .string()
  .trim()
  .nullable()
  .test('valid-phone-number', INVALID_PHONE_NUMBER_MESSAGE, value => {
    if (!value || (value && value.length === 0)) return true;
    return PHONE_NUMBER_REGEX.test(String(value));
  });

export const phoneNumberZodValidationSchema = z
  .string()
  .trim()
  .regex(PHONE_NUMBER_REGEX, INVALID_PHONE_NUMBER_MESSAGE)
  .nullish();
